import { render, staticRenderFns } from "./ManualAdjustments.vue?vue&type=template&id=38da2741&scoped=true"
import script from "./ManualAdjustments.vue?vue&type=script&lang=js"
export * from "./ManualAdjustments.vue?vue&type=script&lang=js"
import style0 from "./ManualAdjustments.vue?vue&type=style&index=0&id=38da2741&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38da2741",
  null
  
)

export default component.exports